import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import dayjs from 'dayjs'
import BaseService from 'services/BaseService'
import { popNotification } from 'utils/popNotification'
import { notificationConfig } from './constants'
import { LIMIT } from 'constants/app.constant'
import { formatDateSend } from '../../functions/formatDateSend'

const { creation, edit, deletion } = notificationConfig

// Redux Toolkit slice
const avoirsFournisseursSlice = createSlice({
    name: 'avoirsFournisseurs',
    initialState: {
        data: [],
        isLoading: false,
        error: null,
        created: null,
        isDeleted: null,
        currentPage: 1,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
        .addCase(fetchDetailsAvoirsFournisseurs.pending, (state) => {
            state.isLoading = true
            state.error = null
        })
        .addCase(fetchDetailsAvoirsFournisseurs.fulfilled, (state, action) => {
            const currentPage = action?.meta?.arg?.page || state.currentPage;

            state.currentPage = currentPage
            state.isLoading = false
            state.data = action.payload
        })
        .addCase(fetchDetailsAvoirsFournisseurs.rejected, (state, action) => {
            state.isLoading = false
            state.error = action.error.message
        })
            .addCase(fetchAvoirsFournisseurs.pending, (state) => {
                state.isLoading = true
                state.error = null
            })
            .addCase(fetchAvoirsFournisseurs.fulfilled, (state, action) => {
                const currentPage = action?.meta?.arg?.page || state.currentPage;

                state.currentPage = currentPage
                state.isLoading = false
                state.data = action.payload
            })
            .addCase(fetchAvoirsFournisseurs.rejected, (state, action) => {
                state.isLoading = false
                state.error = action.error.message
            })
            .addCase(createAvoirsFournisseur.pending, (state) => {
                state.isLoading = true
                state.error = null
            })
            .addCase(createAvoirsFournisseur.fulfilled, (state, action) => {
                state.isLoading = false
                state.created = true
            })
            .addCase(createAvoirsFournisseur.rejected, (state, action) => {
                state.isLoading = false
                state.error = action.error.message
                state.created = false
            })
            .addCase(deleteAvoirsFournisseur.pending, (state) => {
                state.isLoading = true
                state.isDeleted = null
            })
            .addCase(deleteAvoirsFournisseur.fulfilled, (state) => {
                state.isLoading = false
                state.isDeleted = true
            })
            .addCase(deleteAvoirsFournisseur.rejected, (state, action) => {
                state.isLoading = false
                state.error = action.error.message
                state.isDeleted = false
            })
    },
})

// Async thunk action to fetch data from the API
export const fetchAvoirsFournisseurs = createAsyncThunk(
    'avoirsFournisseurs/fetch',
    async (payload) => {
        const page = payload?.page || 1
        const limit = payload?.limit || LIMIT
        const search = payload?.search || ''
        const statut_f = payload?.statut_f || ''
        let date_d_f = payload?.date?.[0] || ''
        let date_f_f = payload?.date?.[1] || ''
        if (dayjs(date_d_f).isValid() && dayjs(date_f_f).isValid()) {
            date_d_f = dayjs(date_d_f).format('YYYY-MM-DD');
            date_f_f = dayjs(date_f_f).format('YYYY-MM-DD');
        } else if (dayjs(date_d_f).isValid()) {
            date_d_f = dayjs(date_d_f).format('YYYY-MM-DD');
            date_f_f = date_d_f;
        } else if (dayjs(date_f_f).isValid()) {
            date_f_f = dayjs(date_f_f).format('YYYY-MM-DD');
            date_d_f = date_f_f;
        }
        try {
            const response = await BaseService.get(
                `/XML/compta.avoir_f.load?page=${page}&limit=${limit}&text=${search}&statut_f=${statut_f}&date_d_f=${date_d_f}&date_f_f=${date_f_f}`
            )

            return response.data
        } catch (error) {
            throw new Error('Failed to fetch avoirsFournisseurs')
        }
    }
)
// Async thunk action to fetch details from the API
export const fetchDetailsAvoirsFournisseurs = createAsyncThunk(
    'AvoirsFournisseurs/fetchDetails',
    async (id) => {
        const data = {'idf':id.id}
        const lbl = {'lbl':'FAC_A_ACH_'+id.id}
        try {
            const AvoirsFournisseur = await BaseService.post(
                `/XML/compta.avoir_f.load/calc_avoir_f_by_id`,data
            )
            const journal = await BaseService.post(
                `/XML/compta.jr.load/get_journal_by_lbl_av`,lbl
            )
            const Fournisseur = await BaseService.post(
                `/XML/ap.fr.load/get_one_fr`,{'idfr':AvoirsFournisseur.data?.idfr}
            )

            return {'avoir':AvoirsFournisseur.data,'journal':journal.data,'Fournisseur':Fournisseur.data}
        } catch (error) {
            throw new Error('Failed to fetch AvoirsFournisseurs')
        }
    }
)
export const createAvoirsFournisseur = createAsyncThunk(
    'avoirsFournisseurs/post',
    async (payload) => {
        const { data, formik, navigate } = payload
        const { resetForm, setSubmitting } = formik
        try {
            const response = await BaseService.post('/avoirsFournisseurs', data)
            if (response.status === 200) {
                resetForm()
                setSubmitting(false)
                popNotification(creation?.success)
                navigate('/avoirsFournisseurs')
            }
        } catch (err) {
            console.log({ err })
            
            setSubmitting(false)
            
            popNotification(creation?.error)
        }
    }
)
export const payAvoirsFournisseur = createAsyncThunk(
    'avoirsFournisseurs/post',
    async (payload) => {
        const { data, formik, navigate } = payload
        const { resetForm, setSubmitting } = formik
        
        try {
           
           const type = data?.transactions?.[0]?.type
           const compte = data?.transactions?.[0]?.compte.split('_')[1]
            const mt = data?.transactions?.[0]?.mt
            const ref = data?.transactions?.[0]?.ref
            const idfact = data?.idfact
            const date_valeur = data?.transactions?.[0]?.date_valeur
            const echeance = data?.transactions?.[0]?.date
            if(type == 'ch'){
                const response = await BaseService.post('/XML/tr.cheque.send/remb_avoir_f', {type:type,compte:compte,mt:mt,ref:ref,idfact:idfact,date_valeur:date_valeur,echeance:echeance})
                if (response.status === 200) {
                    resetForm()
                    setSubmitting(false)
                    popNotification(creation?.success)
                    navigate('/comptabilite/AvoirsFournisseurs')
                }
            }else{
                const response = await BaseService.post('/XML/tr.ba.send/remb_avoir_f', {type:type,compte:compte,mt:mt,ref:ref,idfact:idfact,date_valeur:date_valeur})
                if (response.status === 200) {
                    resetForm()
                    setSubmitting(false)
                    popNotification(creation?.success)
                    navigate('/comptabilite/AvoirsFournisseurs')
                }
            }
            
        } catch (err) {
            console.log({ err })
            
            setSubmitting(false)
            
            popNotification(creation?.error)
        }
    }
)
export const editAvoirsFournisseur = createAsyncThunk('avoirsFournisseurs/edit', async (payload) => {
    const { data, formik, navigate } = payload
    const { resetForm, setSubmitting } = formik
    try {
        const response = await BaseService.put(`/avoirsFournisseurs/${data?.id}`, data)
        if (response.status === 200) {
            resetForm()
            setSubmitting(false)
            popNotification(edit?.success)
            navigate('/avoirsFournisseurs')
        }
    } catch (err) {
        console.log({ err })
        
        popNotification(edit?.error)
    }
})

export const deleteAvoirsFournisseur = createAsyncThunk(
    'avoirsFournisseur/delete',
    async (payload) => {
        const { data,setAvoirsFournisseurAdded } = payload
        try {
            const response = await BaseService.post('/XML/compta.avoir_f.send/delete', data)
            if (response.status === 200) {
                popNotification(creation?.success)
            }
            setAvoirsFournisseurAdded(true)
        } catch (err) {
            console.log({ err })
            
            
            popNotification(creation?.error)
        }
    }
)

export const selectData = (state) => state.avoirsFournisseurs.data
export const selectIsLoading = (state) => state.avoirsFournisseurs.isLoading
export const selectError = (state) => state.avoirsFournisseurs.error
export const selectIsDeleted = (state) => state.avoirsFournisseurs.isDeleted
export const selectCurrentPage = (state) => state.avoirsFournisseurs.currentPage

export default avoirsFournisseursSlice.reducer
